import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { StorageLayout } from '../Layout';

function StorageTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const handleStorageFormLoad = useCallback(() => {
        const timingOptions = [
            { id: 'A', text: 'Ahead' },
            { id: 'B', text: 'Behind' },
        ];
        const storageFrequencyOptions = [
            { id: 'W', text: 'First Day of Week (Sunday)' },
            { id: 'B', text: 'First Day of BI-Week (Every 2nd Sunday)' },
            { id: 'M', text: 'First Day of Month (1st)' },
            { id: 'S', text: 'First Day of Semi Monthly (1st + 16th)' },
            { id: 'A', text: 'Anniversary Date' },
        ];

        // Ensure refs are ready after FormField renders
        setTimeout(() => {
            loadLookupClient("STORAGETIMING", timingOptions);
            loadLookupClient("STORAGEFREQUENCY", storageFrequencyOptions);
        }, 100);
    }, [loadLookupClient]);

    useEffect(() => {
        const timingOptions = [
            { id: 'A', text: 'Ahead' },
            { id: 'B', text: 'Behind' },
        ];
        const storageFrequencyOptions = [
            { id: 'W', text: 'First Day of Week (Sunday)' },
            { id: 'B', text: 'First Day of BI-Week (Every 2nd Sunday)' },
            { id: 'M', text: 'First Day of Month (1st)' },
            { id: 'S', text: 'First Day of Semi Monthly (1st + 16th)' },
            { id: 'A', text: 'Anniversary Date' },
        ];
        loadLookupClient("STORAGETIMING", timingOptions);
        loadLookupClient("STORAGEFREQUENCY", storageFrequencyOptions);
    }, [loadLookupClient, props.formFields?.STORAGETIMING, props.formFields?.STORAGEFREQUENCY]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='6FA92CDE-B3B2-4C36-9966-C5C49E157187'
                layoutName='WMChargeCodeStorageForm'
                defaultFormSchema={StorageLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleStorageFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(StorageTab);


